import { useTranslation } from 'react-i18next';

/**
 * Translation lookups whose keys are built at run time (a room id, a puzzle type…). The typed
 * `t` only accepts literal keys, so these go through a loose signature; the translation tests
 * check that every key a screen can build exists in both languages.
 */
export type LooseT = (key: string, options?: Record<string, unknown>) => string;

export function useLooseT(ns: string): LooseT {
  const { t } = useTranslation(ns as never);
  return t as unknown as LooseT;
}
